<template>
  <div id="user-group-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3">
            <label for="name" class="form-label"><span class="text-danger">*</span> 組別名稱</label>
            <input v-model="form.name" id="name" type="text" class="form-control w-full" placeholder="請輸入組別名稱">
            <div v-if="'name' in errors" class="text-danger mt-2" v-html="errors.name"></div>
          </div>

          <div class="mt-3">
            <label for="description" class="form-label">組別簡介</label>
            <input v-model="form.description" id="description" type="text" class="form-control w-full" placeholder="請輸入組別簡介">
            <div v-if="'description' in errors" class="text-danger mt-2" v-html="errors.description"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" to="/management/user-groups" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'currentSite'],
  data() {
    return {
      mode: 'create',
      form: {
        name: null,
        description: null
      },
      errors: {},
      loading: false,
      finish: false
    }
  },
  watch: {
    data(val) {
      this.init()
    }
  },
  mounted() {
    window.tailwind.svgLoader()
    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.mode = 'update'
      }
    },
    onSave: async function() {
      this.loading = true
      this.errors = {}

      let response

      if (this.mode === 'create') {
        response = await this.createUserGroup(this.currentSite.site_id, this.form)
      } else {
        response = await this.updateUserGroup(this.currentSite.site_id, this.data.group_id, this.form)
      }

      if ('errors' in response.data) {
        this.errors = response.data.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增組別' : '已成功更新組別',
          message: '請稍後，將會轉至組別頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          // Update CurrentSite in App.vue
          await this.$root.$children[0].updateCurrentSiteData()

          setTimeout(() => {
            this.$router.push('/management/user-groups')
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增組別' : '未能更新組別',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
